module["exports"] = [
  "####-#####",
  "####-######"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/phone_number/formats.js
// module id = 1061
// module chunks = 0